export const COLORS = {
    PURPLE: {
        hex: "#2b0062",
    },
    LIGHT_GRAY: {
        hex: "#c1c1c4",
    },
    DARK_GRAY: {
        hex: "#726f76",
    },
    BRIGHT_PURPLE: {
        hex: "#7a128f",
    },
    MIDNIGHT_BLUE: {
        hex: "#9295ae",
    },
};
